/**
 * Japan launch gate (founder directive 2026-08-21). Keep this lightweight:
 * App.tsx reads it on every checkout route, so importing it must not pull the
 * legal-document bundle into the payment entry chunk.
 */
export const JP_MARKET_ENABLED = false;
